<template>
    <div class="ls-image" test-id="image" @click="openImage"><img :src="src" /></div>
</template>

<script>
import VueTypes from 'vue-types';
import { lsModalService } from 'ls-vue-common';

export default {
    name: 'LsImage',
    props: {
        src: VueTypes.string.isRequired,
    },
    methods: {
        openImage() {
            lsModalService.open({
                parent: this,
                content: `<p class="image"><img src="${this.src}"></p>`,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.ls-image {
    max-width: 100px;
    cursor: pointer;
}
</style>
